module.exports = __webpack_public_path__ + "img/arrow_right_square.5ce9b824.svg";